<template>
  <!--  eslint-disable max-len  -->
  <section id="Upgrade">
    <div class="row">
      <div class="title col-md-8 d-flex align-items-center justify-content-start ml-auto">
        <h1 class="h5">獨家優惠</h1>
      </div>
      <div class="col-12">
        <div class="desc mt-30 p-50">
          <p>
            【活動說明】
            <br />2019年期間消費達指定金額，即可獲得抽獎機會。
            <br />年度累積消費達3萬元：累積3張抽獎券
            <br />年度累積消費達5萬元：累積5張抽獎券
            <br />年度累積消費達10萬元：
            <span class="redactor-invisible-space">
              累積10張抽獎券
              <span class="redactor-invisible-space">
                <br />年度累積消費達20萬元：
              </span>
            </span>累積20張抽獎券
            <span class="redactor-invisible-space">
              <br />當季抽獎券可累積，未中獎之抽獎券可持續累積至下次抽獎直到年度活動結束。
              <br />
              <br />
            </span>【活動條件】
            <br />1月至3月達標獎項，將於4/5隨機抽獎，4/10匯入點數
            <br />4月至6月達標獎項，將於7/5隨機抽獎，7/10匯入點數
            <br />7月至9月達標獎項，將於10/5隨機抽獎，10/10匯入點數
            <span class="redactor-invisible-space">
              <br />10月至12月達標獎項，將於2020/1/5隨機抽獎，2020/
              <span class="redactor-invisible-space">
                1/10匯入點數
                <br />
                <br />
              </span>
            </span>【年度獎勵】
            <br />H'S VIBE齊來卡點數10,000點，共5名
            <br />H'S VIBE齊來卡點數1,000點，共50名
            <br />H'S VIBE齊來卡點數100點，共100名
            <span class="redactor-invisible-space">
              <br />H'S VIBE齊來卡點數10點，共500名
              <span class="redactor-invisible-space">
                <br />
                <br />
              </span>
            </span>【注意事項】
            <br />1. 此活動可與其餘累積消費活動同時進行。
            <br />2. 於活動期間抽獎日及點數匯入日將於上述公告日前後兩天執行。
            <br />3. 獎勵配發後無法更改。
            <br />4. 活動內容與各事項可能遇到突發之不可抗力因素變更，漢齊科技擁有變更、修正活動內容之結果與權力。
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'Upgrade',
  metaInfo: {
    title: '年度累積消費達標 | ',
  },
};
</script>
<style lang="scss" scoped>
#Upgrade {
  overflow: hidden;
  padding: 20px 0 100px;
  p,
  li {
    letter-spacing: 1.5px;
  }
  .title {
    border-bottom: 2px solid $primary-light;
  }
  .desc {
    background: linear-gradient(to right, white 30%, $secondary-white 120%);
    p {
      color: $secondary;
    }
    ol {
      &.first {
        list-style-type: disc;
        > li {
          margin-bottom: 10px;
        }
        .second {
          margin-top: 10px;
          > li {
            margin-bottom: 10px;
          }
          .third {
            list-style-type: upper-alpha;
            margin-top: 10px;
            > li {
              margin-bottom: 10px;
            }
            .forth {
              list-style-type: lower-alpha;
              margin-top: 10px;
              > li {
                margin-bottom: 10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
